import { getAvailableFormat, getAvailableTourFormat } from '../lib/format';
import type ru from '../i18n/ru.json';
import { useComponentI18n } from '@/shared/composables/useComponentI18n';
import type { ComputedRef } from 'vue';

type TSchema = typeof ru;

export function useFormatTypes(messages: TSchema, isExperimentFormat?: ComputedRef<boolean>) {
  const { t } = useComponentI18n({ ru: messages });

  const FORMAT_AVAILABLE = getAvailableFormat(t);
  const TOUR_FORMAT_AVAILABLE = getAvailableTourFormat(t);

  const typesAvailable =
    Boolean(isExperimentFormat) && toValue(isExperimentFormat)
      ? [FORMAT_AVAILABLE.INDIVIDUAL, FORMAT_AVAILABLE.GROUP]
      : [FORMAT_AVAILABLE.INDIVIDUAL, FORMAT_AVAILABLE.GROUP, FORMAT_AVAILABLE.MINI_GROUP];

  const tourTypesAvailable = [
    TOUR_FORMAT_AVAILABLE.INDIVIDUAL,
    TOUR_FORMAT_AVAILABLE.GROUP,
    TOUR_FORMAT_AVAILABLE.MINI_GROUP,
  ];

  return {
    FORMAT_AVAILABLE,
    TOUR_FORMAT_AVAILABLE,
    typesAvailable,
    tourTypesAvailable,
  };
}
